// creates a Regex that will match the provided string
export function escapeStringRegExp(str: string) {
  return str.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
}
